import axiosInstance from "../../axios/axiosInstance";
import { ADMIN_LOGIN, CHANGE_PASSWORD, FORGOT_PASSWORD, OTP_VERIFY, REMOVE_FCM_TOKEN, RESEND_OTP, UPDATE_FCM_TOKEN } from "../../constants";



export const adminLogin = (payload) => onResponse => {
    try {
        axiosInstance.post(ADMIN_LOGIN, payload)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const forgotPassword = (payload) => onResponse => {
    try {
        axiosInstance.post(FORGOT_PASSWORD, payload)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const otpVerify = (payload) => onResponse => {
    try {
        axiosInstance.post(OTP_VERIFY, payload)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const otpResend = (props) => onResponse => {
    try {
        axiosInstance.post(RESEND_OTP, props.formData)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const changePassword = (payload) => onResponse => {
    try {
        axiosInstance.post(CHANGE_PASSWORD, payload)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const updateFCM = (props) => onResponse => {
    try {
        axiosInstance.post(UPDATE_FCM_TOKEN, props)
            .then((response) => {
                onResponse(response.data)

            }).catch((err) => { })

    } catch (err) {

    }
}

export const removeFcmToken = (payload) => onResponse => {
    try {
        axiosInstance.post(REMOVE_FCM_TOKEN, payload)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

